import { PropTypes } from 'prop-types';
import { useStyles } from './styles';
import { Icons } from 'components/Icons';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Typography,
} from '@mui/material';

const Props = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  questionsList: PropTypes.array.isRequired,
};

export default function CustomFaq({ title, questionsList, subtitle, alignTitle }) {
  const classes = useStyles();
  return (
    <Container>
      <Typography variant="h2" align={alignTitle || 'center'} className={classes.titleQuestions}>
        {title || 'Frequently Asked Questions'}
      </Typography>

      {subtitle && (
        <Typography className={classes.subtitle} component="p">
          {subtitle}
        </Typography>
      )}

      {questionsList.map((question) => (
        <Accordion className={classes.question} key={question.title}>
          <AccordionSummary
            className={classes.accordionSummaryContent}
            expandIcon={<Icons.expandMore className={classes.expandMoreIcon} />}
          >
            <Typography className={classes.questionTitle}>{question.title}</Typography>
          </AccordionSummary>

          <AccordionDetails className={classes.accordionDetailsParagrath}>
            <p dangerouslySetInnerHTML={{ __html: question.description }}></p>
          </AccordionDetails>
        </Accordion>
      ))}
    </Container>
  );
}

CustomFaq.propTypes = Props;
